export const hasVirtualAssistant = (courseSlug: string, brandSlug: string, videoId: string): boolean => {
    const videosIdsWhereShouldNotDisplayVirtualAssistant = [
        "214031",
        "213901",
        "213910",
        "213905",
        "213917",
        "213918",
        "213902",
        "213920",
        "213914",
        "213916",
        "213904",
        "213903",
        "214028"
    ];

    const proenemCoursesWithAnswerDoubts =
        [
            "med-vip-2025",
            "extensiva-med-25",
            "med-turma-de-marco-25",
            "med-abril-25",
            "med-turma-de-marco-25",
            "med-abril-25",
            "semi-extensiva-med-25",
            "turma-de-junho-med-25",
            "turma-intensiva-25",
            "turma-intensiva-25.set"
        ].includes(courseSlug) && brandSlug === "proenem";
    const promedicinaCoursesWithAnswerDoubts =
        [
            "med-vip-2025",
            "extensiva-med-25",
            "med-turma-de-marco-25",
            "med-abril-25",
            "med-turma-de-marco-25",
            "med-abril-25",
            "semi-extensiva-med-25",
            "turma-de-junho-med-25",
            "turma-intensiva-25",
            "turma-intensiva-25.set"
        ].includes(courseSlug) && brandSlug === "promedicina";

    return (
        !videosIdsWhereShouldNotDisplayVirtualAssistant.includes(videoId) &&
        (!!proenemCoursesWithAnswerDoubts || !!promedicinaCoursesWithAnswerDoubts)
    );
};
